<template>



      <Echarts class="echarts-view" :data="options" />


</template>

<script>
// 引入封装好的 Echarts 组件
import Echarts from '@/components/echarts.vue'

export default {
  name: 'Pie3DChart',
  components: { Echarts },
  data() {
    return {
      // 数据源：包含名称、GMV 值、占比百分比、颜色
      dataList: [
        { name: "炉中火", gmv: 25, ratio: "25%", color: "#D13DF2" },
        { name: "LPX", gmv: 45, ratio: "45%", color: "#6442ee" },
        { name: "三角洲", gmv: 12, ratio: "12%", color: "#6DCDE6" },
        { name: "麦石", gmv: 7, ratio: "7%", color: "#2F54F3" },
        // { name: "已驳回", gmv: 3, ratio: "3%", color: "#8E56E0" }, // 可选数据
      ]
    }
  },
  computed: {
    // ECharts 的图表配置项
    options() {
      const total = this.dataList.reduce((a, b) => a + b.gmv, 0) // 总 GMV
      let sumValue = 0
      const k = 1 // 控制饼图凸起程度的系数

      // 生成每一个 3D 饼图扇区
      const series = this.dataList.map((item) => {
        const startRatio = sumValue / total
        sumValue += item.gmv
        const endRatio = sumValue / total

        return {
          name: item.name,
          type: "surface",
          itemStyle: { color: item.color }, // 区块颜色
          wireframe: { show: false }, // 隐藏网格线
          pieData: item, // 原始数据绑定
          pieStatus: { k, startRatio, endRatio, value: item.gmv },
          parametric: true,
          parametricEquation: this.getParametricEquation(startRatio, endRatio, k, item.gmv),
        }
      })

      // 添加指示线和文字标签
      series.forEach((item, index) => {
        const {
          itemStyle: { color },
          pieStatus: { startRatio, endRatio, value },
        } = item

        this.addLabelLine(series, startRatio, endRatio, value, k, index, color)
      })

      // 返回完整图表配置
      return {
        tooltip: {
          formatter: (params) => {
            // 鼠标悬停提示框
            if (
              params.seriesName !== "mouseoutSeries" &&
              params.seriesName !== "pie2d"
            ) {
              const { gmv, ratio } = series[params.seriesIndex].pieData
              return `${params.seriesName}<br/>
                <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params.color};"></span>
                GMV：${gmv}<br/>
                占比：${ratio}`
            }
            return ""
          },
        },
        xAxis3D: { min: -1, max: 1 },
        yAxis3D: { min: -1, max: 1 },
        zAxis3D: { min: -1, max: 1 },
        grid3D: {
          show: false, // 不显示 3D 坐标轴
          boxHeight: 20, // 图表高度
          viewControl: {
            alpha: 30, // 俯视角度
            distance: 350, // 相机距离
            rotateSensitivity: 0, // 禁用旋转
            zoomSensitivity: 0, // 禁用缩放
            panSensitivity: 1, // 平移灵敏度
            autoRotate: false,
          },
        },
        series, // 所有扇区和标签线的组合
      }
    }
  },
  methods: {
    /**
     * 生成 3D 饼图中每个扇区的参数方程
     * @param {Number} startRatio 扇区起始占比
     * @param {Number} endRatio 扇区结束占比
     * @param {Number} k 控制圆弧的厚度
     * @param {Number} value 当前区块的 GMV 值
     * @returns {Object} 参数方程对象
     */
    getParametricEquation(startRatio, endRatio, k, value) {
      const startRadian = startRatio * Math.PI * 2
      const endRadian = endRatio * Math.PI * 2
      k = typeof k === "number" && !isNaN(k) ? k : 1 / 3

      return {
        u: { min: -Math.PI, max: Math.PI * 3, step: Math.PI / 32 },
        v: { min: 0, max: Math.PI * 2, step: Math.PI / 20 },
        // x 坐标的参数方程
        x(u, v) {
          if (u < startRadian) return Math.cos(startRadian) * (1 + Math.cos(v) * k)
          if (u > endRadian) return Math.cos(endRadian) * (1 + Math.cos(v) * k)
          return Math.cos(u) * (1 + Math.cos(v) * k)
        },
        // y 坐标的参数方程
        y(u, v) {
          if (u < startRadian) return Math.sin(startRadian) * (1 + Math.cos(v) * k)
          if (u > endRadian) return Math.sin(endRadian) * (1 + Math.cos(v) * k)
          return Math.sin(u) * (1 + Math.cos(v) * k)
        },
        // z 坐标的参数方程
        z(u, v) {
          if (u < -Math.PI * 0.5) return Math.sin(u)
          if (u > Math.PI * 2.5) return Math.sin(u) * value * 0.1
          return Math.sin(v) > 0 ? value * 0.1 : -1
        },
      }
    },

    /**
     * 为每个扇区添加连接标签的指示线和文字说明
     * @param {Array} series 图表数据集合
     * @param {Number} startRatio 扇区起始比率
     * @param {Number} endRatio 扇区结束比率
     * @param {Number} value 当前扇区 GMV
     * @param {Number} k 扇区厚度控制参数
     * @param {Number} i 扇区索引
     * @param {String} color 标签颜色
     */
       addLabelLine(series, startRatio, endRatio, value, k, i, color = "#fff") {
      const midRadian = (startRatio + endRatio) * Math.PI
      const radius = 1 + k
      const posX = Math.cos(midRadian) * radius
      const posY = Math.sin(midRadian) * radius
      const posZ = 0.1 * value

      const flag =
        (midRadian >= 0 && midRadian <= Math.PI / 2) ||
          (midRadian >= (3 * Math.PI) / 2 && midRadian <= Math.PI * 2)
          ? 1
          : -1

      const turningPosArr = [
        posX * 1.05 + i * 0.1 * flag + (flag < 0 ? -0.2 : 0),
        posY * 1.05 + i * 0.1 * flag + (flag < 0 ? -0.2 : 0),
        posZ,
      ]

      const endPosArr = [
        posX * 1.1 + i * 0.1 * flag + (flag < 0 ? -0.2 : 0),
        posY * 1.1 + i * 0.1 * flag + (flag < 0 ? -0.2 : 0),
        posZ * 2.5,
      ]

      const name = series[i].name
      const ratio = series[i].pieData.ratio
      const gmv = value

      series.push(
        {
          type: "line3D",
          lineStyle: {
            color,
            width: 2,
          },
          data: [[posX, posY, posZ], turningPosArr, endPosArr],
        },
        {
          type: "scatter3D",
          label: {
            show: true,
            distance: 0,
            position: "center",
            textStyle: {
              color: color,
              backgroundColor: "rgba(0,0,0,0.6)",
              borderColor: color,
              borderWidth: 1,
              borderRadius: 6,
              padding: 6,
              fontSize: 14,
              lineHeight: 20,
              fontWeight: "normal",
              shadowBlur: 10,
              shadowColor: "rgba(0, 0, 0, 0.3)",
            },
            formatter: () => `${name}\nGMV: ${gmv}\n占比: ${ratio}`,
          },
          symbolSize: 0,
          data: [
            {
              name,
              value: endPosArr,
            },
          ],
        }
      )
    },
  }
}
</script>

<style scoped lang="scss">

.echarts-view {

  width: 100%;
  height: 100%;

}

</style>
